// import { saveAs } from "file-saver";
// import JSZip from "JSZip";
import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ReactSession } from "react-client-session";
import EntriesDataContext from "../../context/EntriesDataContext";
import { useNavigate } from "react-router-dom";
import CNDATA from "../pages/CNDATA";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import download from "../../assets/download.svg";
import download_2 from "../../assets/download_2.svg";
import edit from "../../assets/edit.svg";
import submit from "../../assets/submit.svg";
import Cancel from "../../assets/cancel.svg";
import { getSuccessToast, getErrorToast } from "../../toast";
import { toast } from "react-toastify";
import "./StockistReportTable.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import ReconcilationHandler from "../reconcilation/ReconcilationHandler";
import ScanButtton from "../button/ScanButtton";
import CNDialog from "../dialog/CNDialog";
var fileDownload = require("js-file-download");

const StockistReportTable = ({
  minDate,
  maxDate,
  tableData,
  setTableData,
  searchCondition,
  clearRef,
}) => {
  const axiosPrivate = useAxiosPrivate();
  // const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [searched, setSearched] = useState("");
  const [poNo, setPoNo] = useState();
  const [partyName, setPartyName] = useState();
  const [partyList, setPartyList] = useState([]);
  const [partyId, setPartyId] = useState();
  const [partyCode, setPartyCode] = useState();
  const [city, setCity] = useState("");
  const [checked, setChecked] = useState(false);
  const [lrNo, setLrNo] = useState();
  const [lrDate, setLrDate] = useState();
  const [caseNo, setCaseNo] = useState();
  const [goodsType, setGoodsType] = useState();
  const [receivedDate, setReceivedDate] = useState();
  const [openDate, setOpenDate] = useState();
  const [refNo, setRefNo] = useState();
  const [refDate, setRefDate] = useState();
  const [transporterName, setTransporterName] = useState();
  const [srNo, setSrNo] = useState();
  const [editState, setEditState] = useState(false);
  const [boxId, setBoxId] = useState();
  const role = ReactSession.get("role");
  const navigate = useNavigate();
  const { setResData, redirectId, setRedirectId } =
    useContext(EntriesDataContext);
  const partyNameRef = useRef("");
  const [loading, setLoading] = useState(false);
  const username = ReactSession.get("username");
  const [open, setOpen] = useState(false);
  const [currentCNRecord, setCurrentCNRecord] = useState({});

  const [cnDialogOpen, setCnDialogOpen] = useState(false);
  const [currentBoxId, setCurrentBoxId] = useState(null);

  const getRecentEntries = useCallback(async () => {
    try {
      if (role === "2") {
        const response = await axiosPrivate.get(
          "/dashboard/supervisordashboard/"
        );
        setTableData(response.data.data);
        setResData(response.data.data);
      } else {
        const response = await axiosPrivate.get("/dashboard/operatordata/0");
        setTableData(response.data.data);
        setResData(response.data.data);
      }
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectId]);

  useEffect(() => {
    getRecentEntries();
  }, [getRecentEntries]);

  let today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  today = dd + "/" + mm + "/" + yyyy;

  const columns = [
    {
      id: "sr_no",
      width: "4rem",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "Sr No",
    },
    {
      id: "po_no",
      width: "5rem",
      position: "sticky",
      left: "4%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "S. No",
    },
    {
      id: "party_name",
      width: "8rem",
      position: "sticky",
      left: "10%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "Party Name",
    },
    {
      id: "party_code",
      width: "6rem",
      position: "sticky",
      left: "20%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "Party Code",
    },
    {
      id: "city",
      width: "8rem",
      position: "sticky",
      left: "27%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "City",
    },
    {
      id: "status",
      width: "2rem",
      position: "sticky",
      left: "36%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "Status",
    },
    {
      id: "lr_no",
      width: "8rem",
      position: "sticky",
      left: "42%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "LR No",
    },
    {
      id: "lr_date",
      width: "5rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "LR Date",
    },
    {
      id: "ref_no",
      width: "7rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "Claim No.",
    },
    {
      id: "ref_date",
      width: "5rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "Claim Date",
    },
    {
      id: "recieved_date",
      width: "5rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "Recieved Date",
    },

    {
      id: "case_no",
      width: "5rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "No of Cases",
    },
    {
      id: "transporter_name",
      width: "9rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "Transporter Name",
    },
    {
      id: "date",
      width: "5rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "Date",
    },
    {
      id: "user",
      width: "8rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "Created By",
    },
    {
      id: "actions",
      width: "10rem",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
      label: "Actions",
    },
  ];

  if (role !== "2") {
    columns.splice(-2, 1);
  }

  const handleDownload = async (id) => {
    const partyINFO = await axiosPrivate.get(`/data_entry/party-info/${id}/`);
    axiosPrivate
      .get(`/report/download-report/${id}`, {
        responseType: "blob",
      })
      .then((response) => {
        if (response.status === 200) {
          let date = new Date();
          fileDownload(
            response.data,
            `${partyINFO.data["party_code"]}_${formatDate(date)}.xlsx`
          );
        }
        setRedirectId((prev) => prev + 1);
      })
      .catch((error) => {
        if (error.response["status"] === 501) {
          getErrorToast("Expired medicine is not available in claim.", 1000);
        }
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
  }

  const changePartyNameHandler = (e) => {
    setPartyName(e.target.value);
    if (partyNameRef.current.value === "") {
      setPartyCode("");
      setPartyId("");
      setCity("");
    }

    axiosPrivate
      .get(`/data_entry/partymaster_searchbar/?search=${e.target.value}`)
      .then((res) => {
        setPartyList(res.data.results);
      });

    let partyName = partyNameRef.current.value
      .substring(0, partyNameRef.current.value.lastIndexOf(" "))
      .trim();
    let partyCode = partyNameRef.current.value
      .substring(partyNameRef.current.value.lastIndexOf(" "))
      .trim();

    const filteredList = partyList.filter(
      (name) => name["name"] === partyName && name["customer"] === partyCode
    )[0];

    if (filteredList !== undefined) {
      setPartyName(filteredList["name"]);
      setPartyCode(filteredList["customer"]);
      setPartyId(filteredList["party_master_id"]);

      if (filteredList["city"]) {
        setCity(filteredList["city"]);
      } else {
        setCity("");
      }
    }
  };

  const editHandler = (boxId) => {
    tableData.filter((row) => {
      if (row.stockists_master_id === boxId) {
        setBoxId(row.stockists_master_id);
        setEditState(true);

        setPoNo(row.po_number);
        setSrNo(row.serial_number);
        setPartyName(row.party_master__name);
        setPartyCode(row.party_master__customer);
        setCity(row.party_master__city);
        setChecked(row.mark_box);
        setLrNo(row.lr_number);
        setLrDate(row.lr_date);
        setCaseNo(row.case_number);
        setGoodsType(row.goods_type);
        setReceivedDate(row.received_date);
        // setOpenDate(row.open_date);
        setRefNo(row.ref_number);
        setRefDate(row.ref_date);
        setTransporterName(row.transporter_name);
      }
    });
  };

  const updateBoxHandler = (boxId) => {
    const data = {
      po_number: poNo,
      party_master_id: partyId,
      party_master__party_name: partyName,
      party_master__party_code: partyCode,
      party_master__city: city,
      mark_box: checked,
      lr_number: lrNo,
      lr_date: lrDate,
      case_number: caseNo,
      received_date: receivedDate,
      ref_number: refNo,
      transporter_name: transporterName,
    };

    for (const key in data) {
      if (data[key] === "") {
        getErrorToast(`Please fill all the data!`);
        return;
      }
    }

    axiosPrivate
      .patch(`/dashboard/editstockistsdata/${boxId}/`, data)
      .then((res) => {
        if (res.status === 200) {
          getSuccessToast("Data updated successfully", 2000);
          setRedirectId((prev) => prev + 1);
          getRecentEntries();
        }
      })
      .catch((err) => getErrorToast(err));

    setEditState(false);
  };

  const searchBarHandler = (e) => {
    axiosPrivate
      .get(
        `/dashboard/search_stockistsdata/?search=${e.target.value}&start_date=${searchCondition["startDate"]}&end_date=${searchCondition["endDate"]}&operator=${searchCondition["operator"]}`
      )
      .then((response) => {
        setTableData(response.data.results);
      });
  };

  const handleDownloadSaleable = async (id) => {
    const partyINFO = await axiosPrivate.get(`/data_entry/party-info/${id}/`);
    axiosPrivate
      .get(`/report/download-saleable-report/${id}`, {
        responseType: "blob",
      })
      .then((response) => {
        if (response.status === 200) {
          let date = new Date();
          fileDownload(
            response.data,
            `${partyINFO.data["party_code"]}_Sellable_${formatDate(date)}.xlsx`
          );
        }
        setRedirectId((prev) => prev + 1);
      })
      .catch((error) => {
        if (error.response["status"] === 501) {
          getErrorToast("Sellable medicine is not available in claim.", 1000);
        }
      });
  };

  function addSpaces(str) {
    const newStr = str.replaceAll(",", ", ");

    return newStr;
  }

  const RCHandler = (id) => {
    setLoading(true);
    ReactSession.set("box_id", id);
    axiosPrivate
      .get(`reconcilation/reconcile/${id}`)
      .then((res) => {
        console.log(res);
        if (res.data.message) {
          if (res.data.message == "No Scanned Entry for given claim id") {
            navigate("/scan");
          } else {
            if (res.data.bool === true) {
              const data = res.data.data.map((el, i) => {
                return {
                  ...el,
                  sr_no: i + 1,
                };
              });
              navigate("/report", { state: { data: data, img: res.data.img } });
            } else {
              navigate("/reconciled-report", {
                state: { data: res.data.data },
              });
            }
          }
        } else {
          if (res.data.bool === false) {
            navigate("/upload");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const CNHandlerWithOrders = (id, order_types) => {
    setLoading(true);
    const apiToast = toast.loading("API Called!", {
      type: "info",
      theme: "colored",
    });

    const payload = {
      stockists_master_id: id,
      order_types,
    };

    axiosPrivate
      .post(`/data_entry/save-order/`, payload)
      .then((res) => {
        getRecentEntries();
        toast.update(apiToast, {
          render: `success: ${res.data.success} \n message: ${res.data.message}`,
          theme: "colored",
          type: "success",
          isLoading: false,
          autoClose: 2000,
          onClick: () => toast.dismiss(apiToast),
        });
      })
      .catch(() => {
        toast.update(apiToast, {
          render: "Something went wrong!",
          theme: "colored",
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const CNDHandler = (row) => {
    setCurrentCNRecord(row);
    setOpen(!open);
  };

  return (
    <>
      <div className="stockist-report-entries-header-container">
        <div className="stockist-report-entries-header-input-container">
          <input
            ref={clearRef}
            placeholder="Search Details"
            className="entries-header-input"
            type="text"
            onChange={searchBarHandler}
            style={{ width: "50%", paddingLeft: "20px" }}
          />
        </div>
        <TablePagination
          rowsPerPageOptions={[100, 150, 200, 500]}
          component="div"
          count={
            tableData.filter((row) => {
              const oneDayInMs = 86400 * 1000;
              return (
                Date.parse(row.created_on) >= Date.parse(minDate) &&
                Date.parse(row.created_on) <=
                  Date.parse(maxDate) + 1 * oneDayInMs
              );
            }).length
          }
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      <Paper
        style={{
          overflow: "hidden",
        }}
      >
        <TableContainer sx={{ maxHeight: "70vh" }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      padding: "0.5em",
                      textAlign: "center",
                      width: column.width,
                      color: column.color,
                      backgroundColor: "#000000",
                      // position: column.position,
                      // left: column.left,
                      // zIndex: column.z,
                    }}
                    key={column.id}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData
                .filter((row) => {
                  const oneDayInMs = 86400 * 1000;
                  return (
                    Date.parse(row.created_on) >= Date.parse(minDate) &&
                    Date.parse(row.created_on) <=
                      Date.parse(maxDate) + 1 * oneDayInMs
                  );
                })
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, idx) => (
                  <TableRow key={row.stockists_master_id}>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                        //backgroundColor: "#f9f9f9",
                        // position: "sticky",
                        // left: "0%",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <input
                            style={{
                              width: "100%",
                            }}
                            value={srNo}
                            className="disabled"
                            disabled={true}
                          />
                        </>
                      ) : (
                        <>{idx + 1}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                        //backgroundColor: "#f9f9f9",
                        // position: "sticky",
                        // left: "4%",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <input
                            style={{
                              width: "100%",
                            }}
                            value={poNo}
                            onChange={(e) => setPoNo(e.target.value)}
                          />
                        </>
                      ) : (
                        <>{row.po_number}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                        //backgroundColor: "#f9f9f9",
                        // position: "sticky",
                        // left: "12%",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <span>
                          <input
                            style={{
                              width: "100%",
                            }}
                            value={partyName}
                            onChange={changePartyNameHandler}
                            onFocus={changePartyNameHandler}
                            list="party-name"
                            ref={partyNameRef}
                          />
                          <datalist id="party-name">
                            {partyList.map((party) => {
                              return (
                                <option
                                  value={`${party.name} ${party.customer}`}
                                  key={party.party_master_id}
                                >
                                  {party.customer} | {party.city}
                                </option>
                              );
                            })}
                          </datalist>
                        </span>
                      ) : (
                        <>{row.party_master__name}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                        //backgroundColor: "#f9f9f9",
                        // position: "sticky",
                        // left: "26%",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <input
                            style={{
                              width: "100%",
                            }}
                            className="disabled"
                            disabled={true}
                            value={partyCode}
                          />
                        </>
                      ) : (
                        <>{row.party_master__customer}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                        //backgroundColor: "#f9f9f9",
                        // position: "sticky",
                        // left: "34%",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <input
                            style={{
                              width: "100%",
                            }}
                            className="disabled"
                            disabled={true}
                            value={city}
                          />
                        </>
                      ) : (
                        <>{row.party_master__city}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                        //backgroundColor: "#f9f9f9",
                        // position: "sticky",
                        // left: "44%",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => setChecked(!checked)}
                        />
                      ) : (
                        <input
                          readOnly
                          className="box_data_input"
                          type="checkbox"
                          checked={row.mark_box}
                        />
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                        //backgroundColor: "#f9f9f9",
                        // position: "sticky",
                        // left: "46%",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="text"
                          style={{
                            width: "100%",
                          }}
                          value={lrNo}
                          onChange={(e) => setLrNo(e.target.value)}
                        />
                      ) : (
                        <>{row.lr_number}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="date"
                          style={{
                            width: "100%",
                          }}
                          value={lrDate}
                          onChange={(e) => setLrDate(e.target.value)}
                        />
                      ) : (
                        <>{row.lr_date}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                        textWrap: "wrap",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="text"
                          style={{
                            width: "100%",
                          }}
                          value={refNo}
                          onChange={(e) => setRefNo(e.target.value)}
                        />
                      ) : (
                        <>{addSpaces(row.ref_number)}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="date"
                          style={{
                            width: "100%",
                          }}
                          value={refDate}
                          onChange={(e) => setRefDate(e.target.value)}
                        />
                      ) : (
                        <>{row.ref_date}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          style={{
                            width: "100%",
                          }}
                          type="date"
                          value={receivedDate}
                          onChange={(e) => setReceivedDate(e.target.value)}
                        />
                      ) : (
                        <>{row.received_date}</>
                      )}
                    </TableCell>

                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          style={{
                            width: "100%",
                          }}
                          type="text"
                          value={caseNo}
                          onChange={(e) => setCaseNo(e.target.value)}
                        />
                      ) : (
                        <>{row.case_number}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          style={{
                            width: "100%",
                          }}
                          type="text"
                          value={transporterName}
                          onChange={(e) => setTransporterName(e.target.value)}
                        />
                      ) : (
                        <>{row.transporter_name}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {formatDate(row.created_on)}
                    </TableCell>
                    {role !== "2" ? null : (
                      <TableCell
                        style={{
                          fontSize: "0.7em",
                          textAlign: "center",
                          padding: "0.5em",
                        }}
                      >
                        {row.created_by__username}
                      </TableCell>
                    )}
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={() => {
                                updateBoxHandler(row.stockists_master_id);
                              }}
                              className="table-options-btn"
                            >
                              <img src={submit} alt="submit" />
                            </button>
                            <button
                              className="table-options-btn"
                              onClick={() => setEditState(false)}
                            >
                              <img src={Cancel} alt="cancel" />
                            </button>
                          </div>
                        </>
                      ) : (
                        <div>
                          <button
                            onClick={() =>
                              handleDownload(row.stockists_master_id)
                            }
                            // className="table-options-btn"
                            className={
                              row.indicator["download_indigater_e"] == true
                                ? "table-options-btn-green"
                                : "table-options-btn"
                            }
                          >
                            <img src={download} alt="download" />
                          </button>

                          <button
                            onClick={() =>
                              handleDownloadSaleable(row.stockists_master_id)
                            }
                            className={
                              row.indicator["download_indigater_s"] == true
                                ? "table-options-btn-green"
                                : "table-options-btn"
                            }
                          >
                            <img src={download_2} alt="download" />
                          </button>

                          <button
                            onClick={() => {
                              editHandler(row.stockists_master_id);
                            }}
                            className="table-options-btn"
                            disabled={editState}
                          >
                            <img src={edit} alt="" />
                          </button>
                          <ScanButtton row={row} />
                          <ReconcilationHandler row={row} />
                          {username !== "tester" ? (
                            <>
                              <button
                                onClick={() => {
                                  setCurrentBoxId(row.stockists_master_id);
                                  setCnDialogOpen(true);
                                }}
                                className={
                                  row["indicator"]["returnorder"] === true
                                    ? "table-options-btn-green"
                                    : "table-options-btn"
                                }
                              >
                                CN
                              </button>
                              <CNDialog
                                open={cnDialogOpen}
                                onClose={() => setCnDialogOpen(false)}
                                onSubmit={CNHandlerWithOrders}
                                currentBoxId={currentBoxId}
                              />

                              <button
                                onClick={() => CNDHandler(row)}
                                className="table-options-btn"
                                style={
                                  row["cn_date"] === null
                                    ? { display: "none" }
                                    : {}
                                }
                              >
                                CND
                              </button>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
          <Typography position="absolute">Loading...</Typography>
        </Backdrop>
      )}
      {open && <CNDATA open={open} setOpen={setOpen} data={currentCNRecord} />}
    </>
  );
};

export default StockistReportTable;
